import Button from "@components/ui/button";
import DialogBase from "@components/ui/dialog-base";
import Icon from "@components/ui/icon";
import { useFileToStorydocStoreShallow } from "../stores";

export const ErrorStep = ({
  onRetry,
  onClose,
}: {
  onRetry: () => void;
  onClose: () => void;
}) => {
  const errorMsg = useFileToStorydocStoreShallow((s) => s.errorMsg);
  return (
    <DialogBase.Content className="tw-flex tw-min-h-0 tw-w-full tw-flex-1 tw-flex-col tw-p-0 tw-text-center">
      <div className="tw-mx-auto tw-mb-3 tw-grid tw-size-10 tw-place-items-center tw-rounded-full tw-bg-red-50">
        <Icon icon="ri-alert-fill" className="tw-text-red" />
      </div>
      <p className="tw-mb-4 tw-text-sm tw-font-medium tw-text-blue">
        {errorMsg ?? "Something went wrong."}
      </p>
      <div className="tw-flex tw-justify-center tw-gap-2">
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button onClick={onRetry}>Try again</Button>
      </div>
    </DialogBase.Content>
  );
};
